module.exports = __webpack_public_path__ + "static/media/card_m3.c116f160.jpg";